import styled from 'styled-components';

export const Column = styled.div`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    font-size: var(--font-size-sm);
    flex: 0 0 50%;
    margin-top: 2rem;
  }
`;

export const ColumnLinks = styled.ul`
  line-height: var(--line-height-default);
`;

export const ColumnTable = styled.table`
  font-size: var(--font-size-base);

  td {
    &:first-child {
      padding-right: 1rem;
    }
  }
`;

export const ColumnTitle = styled.span`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  display: block;
  margin-bottom: 0.5rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-bottom: 2.5rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
